import { parseBoolean } from "./utils/transforms";

export function transformProductVariant(variant) {
  return {
    id: variant.id,
    name: variant.name,
    product_type_id: variant.field_product_type_.tid,
    product_info: variant.field_more_detailed_information.replace(
      ", full_html",
      "",
    ),
    base_price: variant.field_base_price,
    pricing: variant.field_price_breaks,
    font_categories: variant.field_font_categories.map((category) => {
      return category.tid;
    }),
    options: [],
  };
}

export function transformSingleColor(data) {
  if (!data.id) {
    return null;
  }

  return {
    id: data.id,
    name: data.field_display_name,
    category_id: data.field_category.tid,
    category_name: data.field_category.field_display_name,
    allow_foil_and_embossed: data.field_allow_foil_and_embossed,
    color_mask: data.field_color_mask,
    image: data.field_image,
    is_active: data.field_is_active,
    is_die_cuttable: data.field_is_die_cuttable,
    is_not_foldable: data.field_is_not_foldable,
    is_out_of_stock: data.field_is_out_of_stock,
    is_two_sided: data.field_is_two_sided,
    out_of_stock_until: data.field_out_of_stock_until,
    thumbnail: data.field_thumbnail,
    upcharge: data.field_upcharge,
    changed: data.changed,
  };
}

export function transformColorsResponse(response) {
  return Object.values(response).map(function (data) {
    let colors = data.colors.map((color) => transformSingleColor(color));
    return {
      id: data.category.tid,
      name: data.category.field_display_name,
      weight: data.category.weight,
      colors: colors,
    };
  });
}

export function transformClipart(data) {
  if (!data.id) {
    return null;
  }
  return {
    id: data.id,
    name: data.name,
    changed: data.changed,
    type: data.type,
    url: data.field_clipart_file,
    is_active: parseBoolean(data.field_clipart_active),
    designer_art: parseBoolean(data.field_clipart_designer_art),
    double_stamp: parseBoolean(data.field_clipart_double_stamp),
    size_large: data.field_clipart_size_large,
    size_medium: data.field_clipart_size,
    size_small: data.field_clipart_size_small,
    keywords: data.field_keyword
      ? data.field_keywords.split(",").map((keyword) => keyword.trim())
      : [],
    categories: data.field_category
      ? data.field_category.map((category) => {
          return {
            id: category.tid,
            name: category.name,
            weight: category.weight,
            featured: parseBoolean(category.field_featured_clipart),
          };
        })
      : [],
  };
}

export function transformLayerSet(layer_set) {
  return layer_set.map(function (data) {
    return {
      id: data.id,
      // uuid: data.uuid,
      allow_alignment_edits: data.field_allow_alignment_edits,
      allow_color_edits: data.field_allow_color_edits,
      allow_global_text_settings: data.field_allow_global_text_settings,
      allow_group: data.field_allow_group,
      allow_group_position_edits: data.field_allow_group_position_edits,
      allow_image: data.field_allow_image,
      allow_image_edits: data.field_allow_image_edits,
      allow_image_position_edits: data.field_allow_image_position_edits,
      allow_print_color_edits: data.field_allow_print_color_edits,
      allow_text: data.field_allow_text,
      allow_text_edits: data.field_allow_text_edits,
      allow_text_position_edits: data.field_allow_text_position_edits,
      color: transformSingleColor(data.field_color),
      colors: [],
      color_from_layer: data.field_color_from_layer,
      character_type: data.field_character_type
        ? data.field_character_type.split(",").map((keyword) => keyword.trim())
        : [],
      color_setting_name: data.field_color_setting_name,
      color_setting_type: data.field_color_setting_type.name,
      default_rotation: data.field_default_rotation,
      group_collection_max_len: data.field_group_collection_max_len,
      has_color: data.field_has_color,
      has_print_color: data.field_has_print_color,
      image_collection_max_length: data.field_image_collection_max_len,
      image_collection_name: data.field_image_collection_name,
      image_sizes: data.field_image_sizes,
      image_elements: data.field_image_elements.map((data) => {
        var size

        // Prioritize image width value
        if (data.field_image_width){
          size = data.field_image_width;
        }
        // Default to old size selection if image width is not available
        else if (data.field_image_sizes){
          size = data.field_image_sizes;
        }
        // Default to medium size if no other sizes are present
        else {
          size = 'medium';
        }

        return {
          id: data.id,
          clipart: transformClipart(data.field_clipart),
          userart: transformClipart(data.field_user_art),
          type: data.field_type || "clipart",
          height: data.field_image_height,
          left_position: data.field_image_left_position,
          size: size,
          top_position: data.field_image_top_position,
          width: data.field_image_width,
          rotation: data.field_rotation,
          anchor_point: data.field_anchor_point,
        };
      }),
      is_applique: data.field_is_applique,
      is_cutout: data.field_is_cutout,
      is_debossed: data.field_is_debossed,
      is_embossed: data.field_is_embossed,
      is_foldable: data.field_is_foldable,
      is_monogram: data.field_is_monogram,
      is_raised: data.field_is_raised,
      is_repousse: data.field_is_repousse,
      is_shadow_cut: data.field_is_shadow_cut,
      is_stencil: data.field_is_stencil,
      is_two_sided: data.field_is_two_sided,
      flip_layer: data.field_flip_layer,

      height: data.field_layer_height,
      layer_id: data.field_layer_id,
      layer_mask: data.field_layer_mask,
      layer_name: data.field_layer_name,
      width: data.field_layer_width,
      left_position: data.field_left_position,
      photo_image: data.field_photo_image,
      print_color: transformSingleColor(data.field_print_color),
      print_colors: [],
      print_color_from_layer: data.field_print_color_from_layer,
      print_color_setting_name: data.field_print_color_setting_name,
      print_color_type: data.field_print_color_type.name,
      product_mask: data.field_product_mask,
      supporting_product_option: data.field_supporting_product_option
        ? data.field_supporting_product_option.id
        : null,
      text_collection_max_length: data.field_text_collection_max_length,
      text_collection_name: data.field_text_collection_name,
      text_elements: data.field_text_elements.map(function (data) {
        let font = {};
        if (data.field_font) {
          font = {
            id: data.field_font.id,
            name: data.field_font.name,
          };
        }
        return {
          id: data.field_id,
          uuid: data.uuid,
          size: data.field_size,
          text: data.field_text,
          left_position: data.field_text_left,
          top_position: data.field_text_top,
          font: font,
          is_monogram: data.field_text_is_monogram,
          character_limit: data.field_char_limit,
          title: data.field_text_title,
          transform_amount: data.field_transform_amount || 45,
          transform_type: data.field_transform_type,
          rotation: data.field_rotation,
          letter_spacing: data.field_letter_spacing,
          anchor_point: data.field_anchor_point,
          width: data.field_text_width,
          height: data.field_text_height,
        };
      }),
      top_position: data.field_top_position,
      use_alpha_mask: data.field_use_alpha_mask,
      use_color_mask: data.field_use_color_mask,
      use_layer_mask: data.field_use_layer_mask,
      use_product_mask: data.field_use_product_mask,
    };
  });
}

export function transformProductOption(option) {
  const layer_set = setLayerDimensionsIfNeeded(
    transformLayerSet(option.field_layer_set),
    option.field_printable_area_width_in,
    option.field_printable_area_height_in,
  );
  return {
    id: option.id,
    name: option.name,
    display_name: option.field_display_name,
    sort_order: option.field_sort_order,
    color_setting_type: option.field_color_setting_type,
    //colors: colors, //we pull colors from another place.
    default_image_size: option.field_default_image_size,
    disable_print_plate_check: option.field_disable_print_plate_check,
    display_dimensions: option.field_display_dimensions,
    font_sizes: option.field_font_sizes,
    image_sizes: option.field_image_sizes,
    is_two_sided: option.field_is_two_sided,
    layer_set: layer_set,
    max_printable_area: option.field_max_printable_area,
    max_printable_area_height: option.field_max_printable_area_height,
    max_printable_area_width: option.field_max_printable_area_width,
    // font_thumbnail_path: option.field_font_thumbnail_path,
    // image_size: option.field_image_size,
    preview_height: option.field_preview_height,
    preview_image_width_px: option.field_preview_image_width_px,
    preview_product_width_px: option.field_preview_product_width_px,
    preview_width: option.field_preview_width,
    selected_print_option: option.field_selected_print_option || 0, //default to the first print option
    print_options: option.field_print_options.map((data) => {
      return {
        name: data.field_name,
        filters: data.field_filters.map((filter) => {
          return {
            type_id: filter.field_print_option_filter_type.tid,
            type_name: filter.field_print_option_filter_type.name,
            type_weight: filter.field_print_option_filter_type.weight,
            type_shows_thumbnails:
              filter.field_print_option_filter_type.field_shows_thumbnails,
            value: filter.field_value,
            thumbnail: filter.field_thumbnail,
          };
        }),
        layer_set: data.field_layer_set.map((layer) => {
          return {
            layer_id: layer.field_layer_id,
            allow_image: layer.field_allow_image,
            allow_text: layer.field_allow_text,
            font_sizes: layer.field_font_sizes,
            has_print_color: layer.field_has_print_color,
            is_embossed: layer.field_is_embossed,
            is_repousse: layer.field_is_repousse,
            photo_image: layer.field_photo_image,
            print_color_from_layer: layer.field_print_color_from_layer, //TODO might not be sent over the wire
            print_color_setting_name: layer.field_print_color_setting_name,
            print_color_type: layer.field_print_color_type.name,
            flip_layer: layer.field_flip_layer,
          };
        }),
      };
    }),
    printable_area_height_in: option.field_printable_area_height_in,
    printable_area_width_in: option.field_printable_area_width_in,
    product_height_inches: option.field_product_height_inches,
    product_width_inches: option.field_product_width_inches,
    product_variant_id: option.field_product_variant,
    thumbnail: option.field_thumbnail,
    thumbnail_active: option.field_thumbnail_active,
    thumbnail_hover: option.field_thumbnail_hover,
  };
}

export function setLayerDimensionsIfNeeded(
  layer_set,
  default_width,
  default_height,
) {
  // CHECK AND SEE IF A WIDTH AND HEIGHT ARE SET (because they can be)
  // IF NOT, SET THEM TO EITHER THE PRINTABLE AREA DEFAULT, OR PREVIEW DEFAULT
  // DEPENDING ON IF THEY ALLOW TEXT/IMAGE OR NOT
  return layer_set.map((layer) => {
    const setDefaultDimensions =
      !(layer.height > 0 && layer.width > 0) &&
      (layer.allow_text || layer.allow_image || layer.photo_image);
    return {
      ...layer,
      width: setDefaultDimensions ? default_width : layer.width,
      height: setDefaultDimensions ? default_height : layer.height,
    };
  });
}

export function transformDesign(design) {
  let output = {
    id: design.id,
    name: design.name,
    changed: design.changed,
    is_fyp_product: design.field_is_fyp_product,
    layer_set: transformLayerSet(design.field_layer_set),
    original_design_id: design.field_original_design_id,
    original_designer_id: design.field_original_designer,
    product_type_id: design.field_product_type.tid,
    product_option_id: design.field_product_option.id,
    product_variant_id: design.field_product_variant.id,
    product_info:
      design.field_product_variant.field_more_detailed_information.replace(
        ", full_html",
        "",
      ),
    pricing: design.field_product_variant.field_price_breaks,
    selected_print_option: design.field_selected_print_option || 0, //default to the first print option
    disable_print_plate_check:
      design.field_product_option.field_disable_print_plate_check ||
      design.field_product_variant.field_disable_print_plate_check,
  };
  output.layer_set = setLayerDimensionsIfNeeded(
    output.layer_set,
    design.field_product_option.field_printable_area_width_in,
    design.field_product_option.field_printable_area_height_in,
  );
  return output;
}
